import React from 'react';
import {
  Entity,
  startPositiveEngagement,
  Screen,
} from '@ifit/put-a-ring-on-it';
import { useLocation } from 'react-router-dom';

type EntityValues = 'workout' | 'series' | 'program' | 'trainer' | 'challenge';

export enum LibraryInteractions {
  SearchComplete = 'Library Search Complete',
  WhoopsError = 'Whoops Error',
}

export interface IPositiveEngagement {
  entity: EntityValues;
  id: string;
  [key: string]: unknown;
}

interface IPositiveEngagementOn {
  event: string;
  engagementData: IPositiveEngagement;
}

export interface IAnalyticsWrapperProps {
  startPositiveEngagementData: IPositiveEngagementOn;
  WrapWith?: keyof JSX.IntrinsicElements;
}

export const usePositiveEngagementFn = ({
  entity,
  id,
  ...rest
}: IPositiveEngagement): (() => void) => {
  const { pathname } = useLocation();
  return () => {
    if (entity !== 'trainer') {
      const entityType = entity === 'workout' ? Entity.Workout : Entity.Series;
      startPositiveEngagement({
        screen: Screen.Library,
        entity: entityType,
        id,
        page: pathname,
        ...rest,
      });
    }
  };
};

export const AnalyticsWrapper: React.FC<IAnalyticsWrapperProps> = ({
  children,
  startPositiveEngagementData,
  WrapWith = 'div',
}) => {
  const startPositiveEngagementHandler = {
    [startPositiveEngagementData.event]: usePositiveEngagementFn(
      startPositiveEngagementData.engagementData,
    ),
  };
  return <WrapWith {...startPositiveEngagementHandler}>{children}</WrapWith>;
};
